export default __webpack_public_path__ + "static/media/dubai-marina.0ce85ab9.webp";